<template>
  <div
    class="sidemenu-area"
    v-bind:class="{
      'toggle-sidemenu-area': isOpen,
      'active-sidemenu-area': isOpenMobile,
    }"
  >
    <div class="sidemenu-header">
      <a href="/" class="navbar-brand d-flex align-items-center">
        <img src="@/assets/Logo-crm.png" alt="image" class="logo-main" />
        <img src="@/assets/img/ni-favicon-white.svg" alt="image" class="logo-shorten" />
      </a>
      <div
        class="burger-menu d-none d-lg-block"
        v-bind:class="{ active: isOpen }"
        @click="$emit('toggle-sidebar')"
      >
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
      </div>

      <div
        class="responsive-burger-menu d-block d-lg-none"
        v-bind:class="{ active: isOpenMobile }"
        @click="$emit('toggle-sidebar-mobile')"
      >
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
      </div>
    </div>

    <div v-if="isSSO" class="switch-menu">
      <p>Chuyển menu mới</p>
      <b-form-checkbox v-model="isNewMenu" switch @change="onChangeNewMenu"> </b-form-checkbox>
    </div>

    <SidebarDefault v-if="!isSSO || !isNewMenu" :isOpen="isOpen" :isOpenMobile="isOpenMobile" />
    <SidebarSso v-else :isOpen="isOpen" :isOpenMobile="isOpenMobile" />
  </div>
</template>

<script>
  import keyStore from '@/constant/storeKey'
  import SidebarDefault from './SidebarDefault'
  import SidebarSso from './SidebarSso'

  export default {
    props: {
      isOpen: Boolean,
      isOpenMobile: Boolean,
    },

    components: {
      SidebarDefault,
      SidebarSso,
    },

    data() {
      return {
        isSSO: false,
        isNewMenu: false,
      }
    },

    beforeMount() {
      this.isSSO = localStorage.getItem(keyStore.IS_LOGIN_SSO) === 'true'
      this.isNewMenu = localStorage.getItem(keyStore.IS_NEW_MENU) === 'true'
    },

    methods: {
      onChangeNewMenu() {
        localStorage.setItem(keyStore.IS_NEW_MENU, this.isNewMenu ? 'true' : 'false')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .switch-menu {
    display: flex;
    align-items: center;
    padding: 6px;
    border-bottom: 1px solid #e3e3e3;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */

    p {
      margin-right: 10px;
      font-weight: 600;
    }

    .custom-switch {
      cursor: pointer;
    }

    .custom-control-label {
      line-height: 24px;
    }
  }
</style>
